import React from 'react';
import { motion } from 'framer-motion';

interface ApiResponseDisplayProps {
  apiResponse?: {
    customer_id: string;
    status: string;
  };
}

export const ApiResponseDisplay: React.FC<ApiResponseDisplayProps> = ({ apiResponse }) => {
  if (!apiResponse) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="code-block"
    >
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <span className="text-black-600">{`{`}</span>
        </div>
        
        <div className="ml-4 space-y-1">
          <div className="flex items-center space-x-2">
            <span className="text-blue-600">"customer_id"</span>
            <span className="text-gray-600">:</span>
            <span className="text-green-600">"{apiResponse.customer_id}"</span>
            <span className="text-gray-600">,</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <span className="text-blue-600">"status"</span>
            <span className="text-gray-600">:</span>
            <span className="text-green-600">"{apiResponse.status}"</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <span className="text-black-600">{`}`}</span>
        </div>
      </div>
    </motion.div>
  );
};
